// const BaseUrl = 'https://devtugotwo.ezzysales.com/api/';
// const BaseAssetUrl = 'https://devtugotwo.ezzysales.com/';

const BaseUrl = 'https://api.tugoonline.co.uk/api/';
const BaseAssetUrl = 'https://api.tugoonline.co.uk/';

export { BaseUrl, BaseAssetUrl }
